/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import withFirebaseAuth from 'react-with-firebase-auth';
import * as firebase from 'firebase/app';
import { connect } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'firebase/auth';
import {
  BrowserRouter, Switch, Route, Redirect,
} from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';

import {
  Auth,
  Home,
  Offers,
  Users,
  CurrentUser,
  Companies,
  Company,
} from './pages';
import firebaseConfig from './services/firebase-config';
import { Loader, ToggleMenu, Header } from './ui-kit';
import './ui-kit/styles.scss';
import { PROJECT_NAME } from './services/config';
import UserActions from './store/user/action';
import useComponentWillMount from './services/hook';

const firebaseApp = firebase.initializeApp(firebaseConfig);

const App = ({
  signInWithEmailAndPassword,
  loading,
  signOut,
  error,
  userData,
  ...rest
}) => {
  const [toggleMenuMarker, setTogglemenuMarker] = useState(false);

  const Layout = (props) => (
    <>
      <ToggleMenu menuOpenMarker={(value) => setTogglemenuMarker(value)} menuOpen={toggleMenuMarker} />
      <div id="content" className={toggleMenuMarker ? 'content_menu_opened' : 'content_menu_closed'}>
        <Switch>
          <Route exact path="/">
            <Header signOut={() => rest.logOut(props.signOut)} pageName="Dashboard" history={props.history} />
            <Home />
          </Route>
          <Route exact path="/offers">
            <Header signOut={() => rest.logOut(props.signOut)} pageName="Job offers" history={props.history} />
            <Offers />
          </Route>
          <Route exact path="/users">
            <Header signOut={() => rest.logOut(props.signOut)} pageName="Users" history={props.history} />
            <Users history={props.history} />
          </Route>
          <Route exact path="/user">
            <Header signOut={() => rest.logOut(props.signOut)} history={props.history} />
            <CurrentUser history={props.history} />
          </Route>
          <Route exact path="/companies">
            <Header signOut={() => rest.logOut(props.signOut)} pageName="Companies list" history={props.history} />
            <Companies />
          </Route>
          <Route exact path="/company">
            <Header signOut={() => rest.logOut(props.signOut)} history={props.history} />
            <Company history={props.history} />
          </Route>
          <Redirect from="*" to="/" />
        </Switch>
      </div>
    </>
  );

  const PrivateRoute = ({
    component: Component,
  }) => (
    <Route
      {...rest}
      render={(props) => <Component signOut={signOut} {...props} />}
    />
  );

  useComponentWillMount(() => {
    rest.authorization(() => rest.logOut(signOut));
  });

  if (userData.loading) {
    return (
      <div className="preloader__container">
        <h1>{PROJECT_NAME}</h1>
        <Loader type="big-loader" />
      </div>
    );
  }

  return (
    <BrowserRouter>
      <Switch>
        {userData.success ? (
          <PrivateRoute path="/" component={Layout} signOut={signOut} />
        ) : (
          <>
            <Route
              {...rest}
              path="/"
              exact
              render={(props) => (
                <Auth
                  {...props}
                  error={error}
                  loading={loading}
                  handleLogIn={signInWithEmailAndPassword}
                />
              )}
            />
          </>
        )}
      </Switch>
      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar
        newestOnTop={false}
        limit={5}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </BrowserRouter>
  );
};

const firebaseAppAuth = firebaseApp.auth();

const mapDispatchToProps = (dispatch) => ({
  authorization: (func) => dispatch(UserActions.authorization(func)),
  logOut: (func) => dispatch(UserActions.logOut(func)),
});

const mapStateToProps = (state) => ({
  userData: state.user,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withFirebaseAuth({
  firebaseAppAuth,
})(App));
